import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { decryptData } from "../utils/helpers";

const ProtectedRoute = ({ children }) => {
  const token = Cookies.get("token");
  const enc = Cookies.get("admin_enc");

  // Immediately redirect if no token or no encrypted user
  if (!token || !enc) {
    return <Navigate to="/login" replace />;
  }

  let adminData = null;

  try {
    adminData = decryptData(enc);
  } catch (err) {
    // Corrupted cookie: clean and logout
    Cookies.remove("token");
    Cookies.remove("admin_enc");
    Cookies.remove("sc_id");
    return <Navigate to="/login" replace />;
  }

  // Validate expiry
  const expiresIn = Number(adminData?.expiresIn);

  if (!expiresIn || Date.now() > expiresIn) {
    Cookies.remove("token");
    Cookies.remove("admin_enc");
    Cookies.remove("sc_id");
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
